/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { css } from '@emotion/react';
import { AppDispatch } from '../../store/store';
import { fetchInvite, acceptInvite, resetInvite } from '../../store/slices/inviteSlice';
import { Button, Card, Spin, Result } from 'antd';
import MainLayout from '../../components/common/MainLayout';

const InvitePage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const location = useLocation();
  const accessToken = useSelector((state: any) => state.auth.accessToken);
  const { invite, loading, error, joined } = useSelector((state: any) => state.invite);

  useEffect(() => {
    if (!token) return;
    if (!accessToken) {
      navigate(`/login?redirect=${encodeURIComponent(location.pathname)}`);
      return;
    }
    dispatch(fetchInvite(token));
  }, [token, accessToken, dispatch, navigate, location.pathname]);

  useEffect(() => {
    if (joined) {
      dispatch(resetInvite());
      navigate('/');
    }
  }, [joined, dispatch, navigate]);

  if (!accessToken) {
    return null;
  }

  if (loading && !invite) {
    return (
      <MainLayout>
        <Spin />
      </MainLayout>
    );
  }

  if (error) {
    return (
      <MainLayout>
        <Result status="warning" title={error} />
      </MainLayout>
    );
  }

  if (!invite) {
    return (
      <MainLayout>
        <Result status="404" title="Приглашение не найдено" />
      </MainLayout>
    );
  }

  const handleAccept = () => {
    if (token) {
      dispatch(acceptInvite(token));
    }
  };

  return (
    <MainLayout breadcrumb={<></>}>
      <Card title={`Приглашение в сейв ${invite.saveName}`} css={css({ maxWidth: 400 })}>
        {invite.saveDescription && <p>{invite.saveDescription}</p>}
        <p>Роль: {invite.role}</p>
        <Button type="primary" onClick={handleAccept} loading={loading}>
          Присоединиться
        </Button>
      </Card>
    </MainLayout>
  );
};

export default InvitePage;
